export const BRAND = {
  name: 'Events by AJ',
  founder: 'Abhishek Jindal',
  founderTitle: 'Founder & Anchor AJ',
  tagline: 'We Create Experiences You Cherish Forever.',
  city: 'Hyderabad, Telangana',
  phoneDisplay: '+91 70130 95204',
  phone: '+917013095204',
  whatsapp: '917013095204',
  email: 'hello@eventsbyaj.in',
  website: 'https://www.eventsbyaj.in',
  instagram: 'https://www.instagram.com/eventsby_aj',
  youtube: 'https://youtube.com/@eventsbyaj',
};

export const WHATSAPP_DEFAULT_MSG =
  'Hi Events by AJ, I am interested in planning an event. I would like to know more about your services.';

export const waLink = (msg = WHATSAPP_DEFAULT_MSG) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

export const buildWaLink = (number, msg = WHATSAPP_DEFAULT_MSG) =>
  `https://wa.me/${number || BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

// Add your tracking IDs here later — analytics events fire automatically once set.
export const ANALYTICS = {
  GA_ID: '',
  GTM_ID: '',
  META_PIXEL_ID: '',
};
